"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { imageGalleryTopicDefaultValue } from "@/components/ImageGalleryTopic/ImageGalleryTopic.builder";

export const ImageTopicGalleryComponent: RegisteredComponent = {
  name: "ImageGallery",
  component: dynamic(async () => (await import("./ImageGallery")).ImageGallery),
  canHaveChildren: true,
  childRequirements: {
    message: "Only Image Gallery related components are allowed",
    query: {
      "component.name": {
        $in: ["ImageGalleryTopic"],
      },
    },
  },
  inputs: [],
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "ImageGalleryTopic",
        options: {
          data: imageGalleryTopicDefaultValue,
        },
      },
    },
  ],
};
